import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const inputStyles = "omponents__ui_library__Formik__components__FormElements__Input__Input_styles_ts-inputStyles-in3foim";

require("./Input.styles.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Input.styles.ts");